import { RouterProvider } from "react-router-dom";

import { router } from "@/app/pages/router";

export function App() {
  return <RouterProvider router={router} />;
}
